import { Button, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '../style.module.scss';
import OtpInput from 'react-otp-input';

// import { ReactComponent as TickIcon } from '../../../../public';

import HeaderComponent from '../../LandingPage/Components/Header';
import InputComponent from '../../../components/Input';
import useLoginData from '../Hooks/useLoginData';
import Loader from '../../../components/loader';
import AlertComponent from '../../../components/AlertComponent';
import GoogleLogin from 'react-google-login';
import useCustomerData from '../../LandingPage/Hooks/useCustomerData';

const LoginWithOTPComponent = () => {
  const {
    onMobileNumberChange,
    number,
    otpSent,
    onSendOtpClick,
    otp,
    setOtp,
    onVerifyOtpClick,
    onSignupWithGoogle,
    loading,
    errMsg,
    handleErrorClose,
    showErr,
    seconds,
    setSeconds,
    onResendOtp,
  } = useLoginData();

  const { handleLoginError, handleLoginSuccess } = useCustomerData();

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });
  return (
    <div className={`pb-1 ${styles.otpPage}`}>
      <HeaderComponent />
      <div className={`${styles.otpLoginPage}`}>
        <div className={`${styles.loginContentContainer}`}>
          <h1 className={styles.mainText}>Start Selling with us!</h1>
          <h2 className={styles.smallSemibold}>
            Take advantage of flexible pricing structure.
            <br />
            We’ll show you the product and answer all your questions in 30minutes
          </h2>

          <div className="d-flex align-items-center">
            <img src="/images/Search.svg" />
            <h2 className={`ml-3 ${styles.smallSemibold}`}>
              Cut down your logistics cost by 100%.
            </h2>
          </div>

          <div className="d-flex align-items-start">
            <img src="/images/Search.svg" />
            <h2 className={`ml-3 ${styles.smallSemibold}`}>
              Increase your revenue by more than 50%, Our average customer doubles their revenue
              within 14 months of implementing our platform.
            </h2>
          </div>

          <h2 className={`mt-4 ${styles.secondaryText}`}>Awards & Accolades</h2>
          <div className={`d-flex justify-content-between`}>
            <img
              alt="arzooo-awards-logo"
              className={styles.headerLogo}
              src="/images/awards2-wt-bg.svg"
            ></img>
            <img
              alt="arzooo-awards-logo"
              className={styles.headerLogo}
              src="/images/awards1.svg"
            ></img>
            <img
              alt="arzooo-awards-logo"
              className={styles.headerLogo}
              src="/images/awards3.svg"
            ></img>
          </div>
        </div>
        <div className={`${styles.loginInfoContainer}`}>
          <AlertComponent
            color={'#f44336'}
            msg={errMsg}
            open={showErr}
            handleClose={handleErrorClose}
          />
          {loading && (
            <div className={styles.loaderAbsolute}>
              <Loader noBackground={true} />
            </div>
          )}
          <h1 className={styles.mainText}>{otpSent ? 'Verification OTP' : 'Welcome'}</h1>
          {otpSent ? (
            <div className={`text-center ${styles.smallText} ${styles.otpSentTextContainer}`}>
              We have sent the code verification to your <br />
              <span
                onClick={() => {
                  onSendOtpClick(true);
                }}
                className={`ml-1 ${styles.blueText}`}
              >
                {`+91 ${number}`}
                <img className="ml-1 mb-1" src="/images/pen.svg" />
              </span>
            </div>
          ) : (
            <h2 className={`mt-2 ${styles.smallText}`}>Please Enter your mobile number</h2>
          )}
          {!otpSent ? (
            <div className={`d-flex mt-3 align-items-center ${styles.mobileNumberInputContainer}`}>
              <span>+91</span>
              <img className="ml-2" src="/images/Polygon.svg" />
              <InputComponent
                className={`${styles.mobileNumberInput}`}
                type={'number'}
                value={number}
                placeholder={'Mobile Number'}
                name={'mobileNumber'}
                handleChange={(e) => {
                  onMobileNumberChange(e);
                }}
              />
            </div>
          ) : (
            <OtpInput
              value={otp}
              onChange={setOtp}
              inputType={'number'}
              numInputs={4}
              renderSeparator={<span className="mr-2"></span>}
              renderInput={(props) => (
                <InputComponent
                  {...props}
                  className={`${styles.otpBox} mt-3`}
                  // type={'number'}
                  // value={1}
                  // placeholder={'Mobile Number'}
                />
              )}
            />
          )}

          <button
            disabled={otpSent ? otp.length !== 4 : number?.length !== 10}
            onClick={() => {
              if (otpSent && otp.length === 4) {
                onVerifyOtpClick();
              } else if (number?.length === 10) {
                onSendOtpClick();
              }
            }}
            className={`mt-4 ${
              otpSent || number?.length === 10 ? styles.otpButton : styles.initialOTPButton
            }`}
          >
            <span>
              {otpSent
                ? 'Verify & Proceed'
                : number?.length === 10
                ? 'Get OTP'
                : 'Start selling with Falcon'}
            </span>
          </button>

          {otpSent && (
            <div className={`d-flex mt-4`}>
              <span
                onClick={onResendOtp}
                className={`${styles.tinyFont} ${
                  seconds !== 0 ? styles.disabledText : styles.blueText
                }`}
              >
                ResendOTP
              </span>
              {seconds > 0 && (
                <span className={`ml-2 ${styles.simpleBlueText}`}>
                  0:{seconds < 10 ? `0${seconds}` : seconds}
                </span>
              )}
            </div>
          )}

          {/* <div className={`d-flex align-items-center mt-4`}>
            <div className={`${styles.blueDash}`} />
            <span className={`${styles.tinyFont}`}>Or</span>
            <div className={`${styles.blueDash}`} />
          </div>

          <GoogleLogin
            clientId={'868881563620-53i2nnhl1jrrrco4015u79214pjnncom.apps.googleusercontent.com'}
            render={(renderProps) => (
              <button
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
                className={`d-flex justify-content-center align-items-center ${styles.signupGoogleButton} mt-4`}
              >
                <img src="/images/google.svg" />
                <span className="ml-2">Sign in with Google</span>
              </button>
            )}
            buttonText="Sign In"
            onSuccess={handleLoginSuccess}
            onFailure={handleLoginError}
            cookiePolicy={'single_host_origin'}
          /> */}
        </div>
      </div>
    </div>
  );
};
export default LoginWithOTPComponent;
